import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ReactSelect from 'dashboard/components/ReactSelect';
import { REPORT_TEMPLATE_TYPE_TO_LABEL } from 'dashboard/models/report-template';
import { ModuleResourceReport } from 'dashboard/modules/ResourceReport';
import Spacer from 'design-system/components/Spacer';
import { Heading, Label } from 'design-system/components/Text';
import { ApiModel } from 'lib/interfaces/api';

const Container = styled('div')`
  padding: ${Spacing[5]};
`;

export const REPORT_TEMPLATE_TYPE_OPTIONS = [
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateAddressLookup],
    value: ApiModel.ReportTemplateAddressLookup,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateAdverseMedia],
    value: ApiModel.ReportTemplateAdverseMedia,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessAdverseMedia],
    value: ApiModel.ReportTemplateBusinessAdverseMedia,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessAssociatedPersons],
    value: ApiModel.ReportTemplateBusinessAssociatedPersons,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessClassification],
    value: ApiModel.ReportTemplateBusinessClassification,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessLiensLookup],
    value: ApiModel.ReportTemplateBusinessLiensLookup,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessLookup],
    value: ApiModel.ReportTemplateBusinessLookup,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessNonprofit],
    value: ApiModel.ReportTemplateBusinessNonprofit,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessOnlinePresence],
    value: ApiModel.ReportTemplateBusinessOnlinePresence,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessRegistrationsLookup],
    value: ApiModel.ReportTemplateBusinessRegistrationsLookup,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessSocialMedia],
    value: ApiModel.ReportTemplateBusinessSocialMedia,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessWatchlist],
    value: ApiModel.ReportTemplateBusinessWatchlist,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateBusinessWebsite],
    value: ApiModel.ReportTemplateBusinessWebsite,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateChainalysisAddressScreening],
    value: ApiModel.ReportTemplateChainalysisAddressScreening,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateCryptoAddressWatchlist],
    value: ApiModel.ReportTemplateCryptoAddressWatchlist,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateCustomList],
    value: ApiModel.ReportTemplateCustomList,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateEmailAddress],
    value: ApiModel.ReportTemplateEmailAddress,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateFinraBrokerCheck],
    value: ApiModel.ReportTemplateFinraBrokerCheck,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateMxAccount],
    value: ApiModel.ReportTemplateMxAccount,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplatePhoneNumber],
    value: ApiModel.ReportTemplatePhoneNumber,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplatePoliticallyExposedPerson],
    value: ApiModel.ReportTemplatePoliticallyExposedPerson,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateProfile],
    value: ApiModel.ReportTemplateProfile,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateProfileNonAuthoritative],
    value: ApiModel.ReportTemplateProfileNonAuthoritative,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateSecActionLookup],
    value: ApiModel.ReportTemplateSecActionLookup,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateSentilinkApplicationRisk],
    value: ApiModel.ReportTemplateSentilinkApplicationRisk,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateSentilinkScores],
    value: ApiModel.ReportTemplateSentilinkScores,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateSocialMedia],
    value: ApiModel.ReportTemplateSocialMedia,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateSynthetic],
    value: ApiModel.ReportTemplateSynthetic,
  },
  {
    label: REPORT_TEMPLATE_TYPE_TO_LABEL[ApiModel.ReportTemplateWatchlist],
    value: ApiModel.ReportTemplateWatchlist,
  },
];

export interface ResourceReportPanelProps {
  module: ModuleResourceReport;
  updateModule: (module: ModuleResourceReport) => void;
}

const ResourceReportPanel = ({ module, updateModule }: ResourceReportPanelProps) => {
  const updateReportType = (reportType: ModuleResourceReport['report-template-type']) => {
    updateModule({
      ...module,
      'report-template-type': reportType,
    });
  };

  return (
    <Container>
      <Heading size='sm'>Settings</Heading>
      <Spacer height={3} />
      <Label size='md' weight='bold' id='resource-report-panel__report-template-selector--label'>
        Type
      </Label>
      <ReactSelect<ApiModel>
        id='resource-report-panel__report-template-selector'
        aria-labelledby='resource-report-panel__report-template-selector--label'
        value={module['report-template-type'] || ApiModel.ReportTemplateWatchlist}
        options={REPORT_TEMPLATE_TYPE_OPTIONS}
        onChange={updateReportType}
        portal={true}
      />
    </Container>
  );
};

export default ResourceReportPanel;
